import React from 'react';
import { Droppable } from '@hello-pangea/dnd';
import Column from '../Column';
import {
    BoardSection,
    BoardContainer,
    AddColumnButton
} from '../../styles/ProjectPage.styles';
import { handleColumnOperations, handleCardOperations } from '../../utils/projectHandlers';
import { exportColumnAsJson } from '../../utils/projectExportUtils';

const ProjectBoard = ({
    project,
    labels,
    user,
    areLabelsExpanded,
    projectMembers,
    onCardClick,
    onArchiveAllCards,
    onToggleLabels,
    limitColumnHeight,
    collapsedColumnIds,
    onColumnCollapseToggle,
    enableGithubLinks, // Add new prop
    boardRef // <<< Accept boardRef prop
}) => (
    <BoardSection limitColumnHeight={limitColumnHeight}>
        <Droppable
            droppableId="board"
            direction="horizontal"
            type="COLUMN"
            ignoreContainerClipping={true}
        >
            {(provided) => (
                <BoardContainer
                    {...provided.droppableProps}
                    ref={(el) => { // <<< Assign combined refs
                        provided.innerRef(el);
                        if (boardRef) {
                            boardRef.current = el;
                        }
                    }}
                    limitColumnHeight={limitColumnHeight}
                >
                    {project.columnOrder.map((columnId, index) => {
                        const column = project.columns[columnId];
                        const isCollapsed = collapsedColumnIds.includes(column.id);
                        return (
                            <Column
                                key={column.id}
                                column={column}
                                cards={column.cards.filter(card => !card.archived) || []}
                                labels={labels}
                                index={index}
                                onAddCard={(columnId, cardTitle) => handleCardOperations.add(project.id, project, columnId, cardTitle, user)}
                                onCardClick={(card) => onCardClick(card, column)}
                                onUpdateColumn={(updates) => handleColumnOperations.update(project.id, project, column.id, updates)}
                                onDeleteColumn={() => handleColumnOperations.delete(project.id, project, column.id)}
                                onArchiveAllCards={onArchiveAllCards}
                                areLabelsExpanded={areLabelsExpanded}
                                onToggleLabels={onToggleLabels}
                                projectMembers={projectMembers}
                                limitColumnHeight={limitColumnHeight}
                                isCollapsed={isCollapsed}
                                onToggleCollapse={onColumnCollapseToggle}
                                enableGithubLinks={enableGithubLinks} // Pass down
                                projectId={project.id} // Pass projectId
                                allColumns={project.columns} // Pass allColumns
                                columnOrder={project.columnOrder} // Pass columnOrder
                                projectLabels={project.labels || []} // Pass project labels
                                onExportList={() => exportColumnAsJson(column, {
                                    projectTitle: project.title,
                                    projectLabels: project.labels || [],
                                    projectMembers,
                                })}
                            />
                        );
                    })}
                    {provided.placeholder}
                    <AddColumnButton onClick={() => handleColumnOperations.add(project.id)}> {/* <--- Modified call, removed 'project' argument */}
                        + Add another column
                    </AddColumnButton>
                </BoardContainer>
            )}
        </Droppable>
    </BoardSection>
);

export default ProjectBoard;